export class SaveCurrentPositionData {
  constructor(data) {
    this.name = data.name;
    this.courseId = data.courseId;
    this.languageId = data.languageId;
  }
}
